module.exports = function(app) {
	"use strict";
  app
  .directive('searchPollDir',searchPollDir);
	searchPollDir.$inject = ['keyPress','$timeout','serverError','alertService','refreshtokenService','offlineError','postDataService','getDataService','$rootScope'];
    function searchPollDir(keyPress,$timeout,serverError,alertService,refreshtokenService,offlineError,postDataService,getDataService,$rootScope) {
    return {
      restrict: 'E',
      scope: {
          parentObj:"=",
          editor:'=',
          postId:'=',
          pollResultDisplay:'='
      },
      replace:true,
      template: require('./partial/searchPoll.html'),
      link: function(scope, element, attrs, ngModel) {
        scope.requiredPoll = false;
        scope.pollResult = false;
        scope.insertPoll = function() {
          function addPollFunc() {
            if(scope.parentObj.addPollToEditorShow) {
              var insertPollToEditorObj = {
                _id: scope.searchObj._id,
              }
              if(scope.pollResultDisplay) {
                insertPollToEditorObj.result = scope.pollResult
              }
              scope.$parent.$parent.$broadcast('insert-poll-to-editor', insertPollToEditorObj);
            } else {
              scope.parentObj.setRecommnededPoll({
                _id : scope.searchObj._id,
                title: scope.searchObj.title
              })
            }
            searchPollReset()
            // scope.selectedPollAction.value = 'default';
            $timeout(function () {
              scope.parentObj.cancelPollModal()
            }, 0)
          }
          if(scope.searchObj && scope.searchPollData) {
            scope.requiredPoll = false;
            if(scope.postId) {
              var postFunction = function() {
                postDataService.save({
                  param1:'polls',
                  param2:'attachToPost'
                },{
                  'post_id':scope.postId,
                  'poll_id':scope.searchObj._id,
                  'related': (scope.parentObj.addPollToRecomended)? true:false
                }).$promise.then(function(data){
                  addPollFunc()
                  scope.pollModalShow = false;
                  $rootScope.modalShow = false;
                }, function(error){
                  if(!window.navigator.onLine) {
                    offlineError()
                    alertService('danger','Opps! ', 'Please check your internet connection and try again.');
                    return
                  }
                  if(error.status ==401) {
                    var promise = refreshtokenService.getAccessToken();
                    promise.then(
                      function(answer) {
                        if(answer==200) {
                          postFunction();
                        }
                      },
                      function(error) {
                      },
                      function(progress) {
                        // report progress
                    });
                  } else if(error.status ==502) {
                    serverError()
                  } else {
                    alertService('danger','Opps! ', (error && error.data && error.data.error && error.data.error.message)? error.data.error.message:'Failed to load response data.');
                  }  
                });
              }
              postFunction();
            } else {
              addPollFunc()
            }
          } else {
            alertService('danger','Opps! ', 'Choose poll');
            scope.requiredPoll = true;
          }  
        }
        scope.hiddenResult = true;
        scope.hasResult = true;
        scope.pollArray = [];
        scope.searchPage = 0;
        scope.chooseSearchData = function(poll) {
          scope.searchPollData = '('+poll._id+') - ' +  poll.title;
          scope.hiddenResult = true;
          scope.searchObj = {
            '_id': poll._id,
            'title' : poll.title,
          };
        };
        function mouseDown(e) {
          if(angular.element(document.getElementsByClassName("autocomplete-result"))) {
          var container = angular.element(document.getElementsByClassName("autocomplete-result"));
          var serch_input = angular.element(document.getElementsByClassName("search-autocomplete"));
          if (!container.is(e.target) // if the target of the click isn't the container...
            && container.has(e.target).length === 0 && !scope.hiddenResult && !serch_input.is(e.target) && serch_input.has(e.target).length===0) // ... nor a descendant of the container
          {
            scope.$apply(function () {
              scope.hiddenResult = true;
              scope.pollArray = [];
              scope.searchPage = 1;
            });
          }}
        }
        angular.element(document).on('mousedown',mouseDown);
        scope.searchPress = function(evt,star) {
          keyPress(evt,star);
        }
        scope.readMore = function() {
          scope.searchPage ++;
          $timeout(function() {
            scope.search('loadMore');
          },0)
        }
        var getPollsFunction = function(loadMore) {
          var excludeby;
          var status = 'publish,finish';
          if(scope.parentObj.addPollToRecomended) {
            excludeby = 'content';
            status = 'publish'
          }
          getDataService.get({
            param1:'polls', 
            status:status,
            s: scope.searchPollData,
            limit:20,
            page: scope.searchPage,
            excludeby:excludeby
          }).$promise.then(function(data){
            // $element.after($compile(modal)($scope));
            if(loadMore=='loadMore') {
              scope.pollArray = scope.pollArray.concat(data.polls);
            } else {
              scope.pollArray = data.polls;
            }
            if(scope.pollArray.length > 0) {
              scope.hasResult = true;
              scope.loadMore = true;
            } else {
              scope.hasResult = false;
            }
            scope.hiddenResult = false;
            if(data.count >scope.pollArray.length) {
              scope.loadMore = true;
            } else {
              scope.loadMore = false;
            }
          }, function(error){
            if(!window.navigator.onLine) {
              offlineError()
              return
            }
            if(error.status ==401) {
              var promise = refreshtokenService.getAccessToken();
              promise.then(
                function(answer) {
                  if(answer==200) {
                    getPollsFunction(loadMore);
                  }
                },
                function(error) {
                },
                function(progress) {
                  // report progress
              });
            } else if(error.status ==502) {
              serverError()
            } else {
              alertService('danger','Opps! ', (error && error.data && error.data.error && error.data.error.message)? error.data.error.message:'Failed to load response data.');
            }  
          });
        }
        function searchPollReset() {
          scope.searchPollData = null;
          scope.searchObj = null;
        }
        scope.search = function(loadMore,initialLoad) { 
          scope.loadMore = false;
          if(loadMore!='loadMore') {
            scope.searchPage = 1;
            scope.pollArray = [];
          }
          if(initialLoad || loadMore) {
            getPollsFunction(loadMore);
          } else {
            if(scope.searchPollData) { 
              if(scope.searchPollData.length >0) {
                getPollsFunction(loadMore);
              } else {
                scope.hiddenResult = true;
              } 
            } else {
              scope.hiddenResult = true;
              searchPollReset()
            }
          }
          // scope.hiddenResult = true;
        }
        scope.search(null,true)
        scope.$on('$destroy',function(){
          angular.element(document).off('mousedown',mouseDown);
        })
      }
    }
  }	
}


//////////////////
// WEBPACK FOOTER
// ./public/development/assets/app/js/directive/searchPoll/searchPollDirective.js
// module id = 448
// module chunks = 0